import { Link, useNavigate, useParams } from "react-router-dom";
import { Button as Btn } from "antd";

import BackButton from "shared/components/BackButton/BackButton";
import { useTranslation } from "contexts/TranslationContext";

import schoolAlnubalaa from "assets/svg/schoolAlnubalaa.svg";
import schoolDigitalCulture from "assets/svg/schoolDigitalCulture.svg";
import schoolMinnha from "assets/svg/schoolMinnha.svg";

import schoolInterlude from "assets/svg/schoolInterlude.svg";
import schoolACHET from "assets/svg/schoolACHET.svg";
import schoolADCCC from "assets/svg/schoolADCCC.svg";
import schoolAlabda from "assets/svg/schoolAlabda.svg";
import schoolYa from "assets/svg/schoolYa.svg";
import alMashael from "assets/svg/alMashael.png";
import KenzelLogo from "assets/svg/kenzelLogo.svg";
import almana from "assets/svg/almana.png";

import { toast } from "react-toastify";
import env from "shared/constants/env";
import routes, { appRoute } from "shared/constants/routes";
import { useGetUserAppsQuery } from "services/auth";

const DentalListing = () => {
  const navigate = useNavigate();
  const { translate, language } = useTranslation();
  const { data, isLoading, refetch } = useGetUserAppsQuery(
    JSON.parse(localStorage.getItem("@@TAMWEEL_USER"))?.IDB_USR_ID
  );
  const user = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

  const products = [
    {
      id: 1,
      title: translate("HOME.KENZEL_DENTAL"),
      description: "HOME.PERSONAL_DESC",
      image: KenzelLogo,
      route: 1,
    },
    {
      id: 2,
      title: translate("HOME.SCHOOL_AL_MANA"),
      description: "HOME.PERSONAL_DESC",
      image: almana,
      route: 2,
    },
  ];

  const handleApplyNow = async (route) => {
    if (
      data?.length >= 4
      //  && Array.isArray(data)
      //  && data.some(item => item.CONTRACT_STATUS !== 'SIGNED')
    ) {
      toast.error(translate("APPLICATION_ALREADY_EXISTS"));
      return;
    }

        try {
            const preAppStatus = await fetch(`${env.API_ENDPOINT_V2}app/pre-app-status?id=${JSON.parse(localStorage.getItem("@@TAMWEEL_USER"))?.IDB_USR_ID}`)

            const response = await preAppStatus.json()

      if (
        response?.result?.completedSteps.length >= 4 &&
        response?.result?.status === "COMPLETED"
      ) {
        navigate(appRoute(routes.DENTAL + `/${route}`));
      } else {
        navigate(appRoute(routes.PRE_APP));
        toast.error("Please complete pre-application steps and try again.");
      }
    } catch (error) {
      console.error("Pre-App Status error:", error);
      toast.error(
        "Something went wrong in checking pre app status. Please try again."
      );
    }
  };

  return (
    <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
      <div className="p-5">
        {/* Back button */}
        <div className="flex items-center space-x-4">
          <div className="ml-3">
            <BackButton onClick={() => navigate(-1)} />
          </div>
          <span className="text-[#1F225B] text-2xl font-light">
            {translate("HOME.DENTAL_PRODUCTS_TITLE")}
          </span>
        </div>

        <div className="container mx-auto px-4 my-5 pt-5">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product, index) => (
              <div key={product.id} className="bg-white rounded-lg shadow-md">
                <div className="relative w-full h-48 rounded-t-lg overflow-hidden">
                  <div className="relative w-full h-48 rounded-t-lg overflow-hidden bg-[linear-gradient(to_left,#E1DBDB,#F9F9F9)] flex items-center justify-center">
                    <img
                      src={product.image}
                      alt={`Product-Image-${index}`}
                      className="relative z-10 p-4 w-[50%] max-h-full object-contain"
                    />
                  </div>
                </div>

                <div className="p-6">
                  <div className="my-3">
                    <h3 className="text-[#1F225B] text-xl font-semibold mb-2">
                      {product.title}
                    </h3>
                    <p className="text-[#8E9196] text-base mb-4">
                      {translate(product.description)}
                    </p>
                  </div>

                  <Btn
                    className={
                      "rounded-full bg-primary text-white font-semibold p-4 w-fit border border-primary hover:!border-primary hover:border-solid hover:!text-primary"
                    }
                    onClick={() => handleApplyNow(product.route)}
                    // disabled={(user?.USER_ID && !user?.USER_ID?.toString().startsWith('1'))}
                    // className={(user?.USER_ID && !user?.USER_ID?.toString().startsWith('1')) ? "!bg-blue-950 !text-white border-none font-bold p-5 w-36 rounded-full cursor-not-allowed" : "rounded-full bg-primary text-white font-semibold p-4 w-fit border border-primary hover:!border-primary hover:border-solid hover:!text-primary"}
                    // onClick={() => handleApplyNow(product.route)}
                    // disabled={(user?.USER_ID && !user?.USER_ID?.toString().startsWith('1'))}
                  >
                    {translate("HOME.CREATE_NEW")}
                    {/* {(user?.USER_ID && !user?.USER_ID?.toString().startsWith('1')) ? translate("VOUCHERS.COMING_SOON") : translate("HOME.CREATE_NEW")} */}
                  </Btn>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DentalListing;
